<mat-accordion  displayMode="default" [multi]="true">
  <ng-container *ngIf="isLoading; else panelContent">
    <mat-expansion-panel *ngFor="let _ of [1,2,3]" class="custom-expansion-panel">
      <mat-expansion-panel-header>
        <div class="header-content">
          <div class="header-left">
            <div class="skeleton skeleton-title"></div>
            <div class="skeleton skeleton-subtitle"></div>
          </div>
          <div class="header-right">
            <div class="skeleton skeleton-circle"></div>
          </div>
        </div>
      </mat-expansion-panel-header>
    </mat-expansion-panel>
  </ng-container>

  <ng-template #panelContent>
    <mat-expansion-panel *ngFor="let device of listViewData" class="custom-expansion-panel">
      <mat-expansion-panel-header [ngStyle]="{'background-color': device.assetHealthStatusColor}" class="mt-exp">
        <mat-panel-title class="panel-header">
          <div class="header-content">
            <div class="header-left">
              <span class="asset-name">{{ device.assetName }}</span>
              <span class="app-name">{{ device.applicationName }}</span>
            </div>
            <div class="header-right">
              <span class="device-count" matTooltip="Connected Devices">
                {{ device.connectedSensorsCount }}
                {{ device.connectedSensorsCount === 1 ? "Device" : "Devices" }}
              </span>

              <span
                class="status-dot"
                matTooltip="Asset Status: {{ device.assetOnlineStatusColor === '#fcda44' ? 'Out For Service' : device.assetOnlineStatusColor === '#f3291c' ? 'Offline' : device.assetOnlineStatusColor === '#000000' ? 'Undefined' : 'Online' }}"
                [ngStyle]="{'background-color': device.assetOnlineStatusColor}"
              ></span>
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="panel-content">
        <table class="device-table mat-elevation-z2">
          <thead>
            <tr>
              <th rowspan="2">Device Name</th>
              <th rowspan="2">Serial Number</th>
              <th rowspan="2">Status</th>
              <th colspan="3" class="sub-header">Triaxial Vibration (mm/s)</th>
              <th colspan="2" class="sub-header">Temperature (&deg;C)</th>
              <th rowspan="2">Acoustics (dBA)</th>
              <th rowspan="2">Δ Ultrasonic</th>
              <!-- <th rowspan="2">Link</th> -->
            </tr>
            <tr>
              <th>H</th>
              <th>V</th>
              <th>A</th>
              <th>Skin</th>
              <th>Core</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let sensor of device.connectedSensors">
              <td><b>{{ sensor.deviceName }}</b></td>
              <td><b>{{ sensor.serialNumber }}</b></td>
              <td>
                <mat-icon
                  [ngStyle]="{ color: sensor.deviceConnectivityStatus === 2 ? 'red' : 'green' }"
                  [matTooltip]=" sensor.deviceConnectivityStatus === 2 ? 'Offline' : 'Online'"
                >
                  {{ sensor.deviceConnectivityStatus === 2 ? 'wifi_off' : 'wifi' }}
                </mat-icon>
              </td>

              <td [style.backgroundColor]="sensor.sensorData?.z_velocity?.backgroundColor"><b>{{ sensor.sensorData?.z_velocity?.value || 'N/A' }}</b></td>
              <td [style.backgroundColor]="sensor.sensorData?.y_velocity?.backgroundColor"><b>{{ sensor.sensorData?.y_velocity?.value || 'N/A' }}</b></td>
              <td [style.backgroundColor]="sensor.sensorData?.x_velocity?.backgroundColor"><b>{{ sensor.sensorData?.x_velocity?.value || 'N/A' }}</b></td>
              <td [style.backgroundColor]="sensor.sensorData?.temperature_skin?.backgroundColor"><b>{{ sensor.sensorData?.temperature_skin?.value || 'N/A' }}</b></td>
              <td [style.backgroundColor]="sensor.sensorData?.temperature_core?.backgroundColor"><b>{{ sensor.sensorData?.temperature_core?.value || 'N/A' }}</b></td>
              <td [style.backgroundColor]="sensor.sensorData?.audible?.backgroundColor"><b>{{ sensor.sensorData?.audible?.value || 'N/A' }}</b></td>
              <td [style.backgroundColor]="sensor.sensorData?.ultrasound?.backgroundColor"><b>{{ sensor.sensorData?.ultrasound?.value || 'N/A' }}</b></td>
              <!-- <td>
                <mat-icon
                  class="link-icon"
                  matTooltip="Disabled"
                  style="color: #b0b0b0; cursor: not-allowed;"
                >
                  open_in_new
                </mat-icon>
              </td> -->
            </tr>
          </tbody>
        </table>
      </div>
    </mat-expansion-panel>
  </ng-template>
</mat-accordion>
